class PremiumBlogCards extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.cards = Array.from(this.querySelectorAll('[data-premium-blog-card]'));
    this.effectTimers = new WeakMap();
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.onPointerDown = this.handlePointerDown.bind(this);
    this.onBlockSelect = this.handleBlockSelect.bind(this);

    this.cards.forEach((card) => card.addEventListener('pointerdown', this.onPointerDown));
    document.addEventListener('shopify:block:select', this.onBlockSelect);

    if (this.dataset.animate === 'true' && 'IntersectionObserver' in window && !this.reduceMotion) {
      this.observer = new IntersectionObserver(this.handleIntersection, {
        rootMargin: '120px',
        threshold: 0.08,
      });
      this.observer.observe(this);
    } else {
      this.dataset.inView = 'true';
    }
  }

  disconnectedCallback() {
    this.cards?.forEach((card) => {
      card.removeEventListener('pointerdown', this.onPointerDown);
      this.effectTimers?.get(card)?.forEach((timer) => window.clearTimeout(timer));
    });
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
    this.observer?.disconnect();
  }

  handlePointerDown(event) {
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    const card = event.currentTarget;
    const bounds = card.getBoundingClientRect();
    card.style.setProperty('--click-x', `${event.clientX - bounds.left}px`);
    card.style.setProperty('--click-y', `${event.clientY - bounds.top}px`);
    this.restartEffect(card, 'is-clicked', 620);
  }

  handleBlockSelect(event) {
    const card = event.target.closest?.('[data-premium-blog-card]');
    if (!card || !this.contains(card)) return;

    this.restartEffect(card, 'is-selected', 1100);
    card.scrollIntoView({ behavior: this.reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
  }

  restartEffect(card, className, duration) {
    const timers = this.effectTimers.get(card) || new Map();
    window.clearTimeout(timers.get(className));
    card.classList.remove(className);

    requestAnimationFrame(() => {
      card.classList.add(className);
      const timer = window.setTimeout(() => card.classList.remove(className), duration);
      timers.set(className, timer);
      this.effectTimers.set(card, timers);
    });
  }

  handleIntersection = (entries) => {
    if (!entries[0]?.isIntersecting) return;
    this.dataset.inView = 'true';
    this.observer?.disconnect();
  };
}

if (!customElements.get('premium-blog-cards')) {
  customElements.define('premium-blog-cards', PremiumBlogCards);
}
